<template>
  <span
    v-if="isParentSelected"
    :class="triggerClass"
    class="tw-inline-flex tw-flex-wrap tw-items-center tw-gap-1"
  >
    <span v-if="titlePrefix">{{ titlePrefix }}</span>
    <slot />
    <span v-if="titleSuffix">{{ titleSuffix }}</span>
  </span>
  <span v-else v-dompurify-html="title" :class="triggerClass"> </span>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue'
import { usePeriodSelectionTrigger } from '../composables/use-period-selection-trigger'
import type { PeriodSelectionOption } from '../types'

interface Props {
  periodSelectionOption: PeriodSelectionOption
  isParentSelected: boolean
  // The resolved date/lock-type text, each dropdown computes this itself
  // (the date/lock-type dropdowns interpolate different params), reused here
  // both as the unselected row's plain text and inside the selected button.
  value: string
}
const props = defineProps<Props>()

const { titlePrefix, titleSuffix, title, triggerClass } =
  usePeriodSelectionTrigger(toRefs(props))
</script>
